import Storage from 'src/utils/storage/storage';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import {
  addNewComment,
  updateComment,
  deleteCommentById
} from '../store/planner-slice-async-thunks';

export default function useProductComment() {
  const { id: scenarioId } = useParams();
  const { source: sourceId } = Storage.getSourceId();
  const { moduleNameToModuleIdMap } = useAppSelector(
    (state) => state.simulatorHome
  );
  const appDispatch = useAppDispatch();

  const handleAddComment = (
    payload: { [key: string]: unknown, comment_text: string }
  ) =>
    appDispatch(
      addNewComment({
        params: payload,
        sourceId,
        moduleId: moduleNameToModuleIdMap.planner,
        scenarioId: Number(scenarioId),
      })
    );

  const handleUpdateComment = (commentId: number, updatedComment: string) =>
    appDispatch(
      updateComment({
        commentId,
        commentText: updatedComment
      })
    );

  const handleDeleteComment = (commentId: number) =>
    appDispatch(deleteCommentById(commentId));

  return {
    handleAddComment,
    handleUpdateComment,
    handleDeleteComment
  };
}
